// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1zDQc","title":"AfterBackImages_title__1suJ-","images":"AfterBackImages_images__rlMRk"};